import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit'
import { login } from 'store/auth/thunks'
import { initialAuthState } from 'store/auth/initial.ts'
import { PURGE } from 'redux-persist'

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {},
  extraReducers: (builder) => {
    // SPECIFIC THUNK REDUCERS
    builder.addCase(login.fulfilled, (state, { payload }) => {
      state.email = payload.email
      state.role = payload.role
    })

    // PERSIST
    builder.addCase(PURGE, (state) => {
      state.email = initialAuthState.email
      state.role = initialAuthState.role
    })

    // IS PENDING MATCHER
    builder.addMatcher(isPending(login), (state) => {
      state.loading = true
      state.error = null
    })

    // IS FULFILLED
    builder.addMatcher(isFulfilled(login), (state) => {
      state.loading = false
      state.error = null
    })

    // IS REJECTED
    builder.addMatcher(isRejected(login), (state, { payload }) => {
      state.loading = false
      state.error = (payload as string) || null
    })
  }
})

export default authSlice.reducer
